export interface IPositionProps {
  top: number;
  right: number;
  bottom: number;
  left: number;
}
/**
 * @param container is the container in which you measure the elements you want to know is in view.
 * This can be a div, but it can also be window.
 * @param element is the element you want to measure
 * @param offsetX is the horizontal offset in which you take the measure
 * @param offsetY is the vertical offset in which you take the measure
 * @returns a boolean
 */
const isInView = (container: IPositionProps, element: IPositionProps, offsetX = 0, offsetY = 0) => {
  const isInHorizontalView =
    element.left < container.right + offsetX && element.right > container.left - offsetX;
  const isInVerticalView =
    element.top < container.bottom + offsetY &&
    element.bottom > container.top - (element.bottom - element.top) - offsetY;

  return isInHorizontalView && isInVerticalView;
};

export default isInView;
